module.exports = __webpack_public_path__ + "img/ff1d2b446c257bb2fcdccd87cbc40247.png";


//////////////////
// WEBPACK FOOTER
// ./classes/heroes/seb/assets/sprites/seb_02.png
// module id = 59
// module chunks = 0